var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.07368 5.46224L6.07439 5.46298C6.14094 5.53219 6.19436 5.61518 6.23102 5.70744C6.26768 5.79972 6.2867 5.89908 6.2867 5.9997C6.2867 6.10032 6.26768 6.19969 6.23102 6.29197C6.19436 6.38423 6.14094 6.46722 6.07439 6.53642L6.07368 6.53717L2.03071 10.7764C2.03058 10.7766 2.03046 10.7767 2.03033 10.7768C1.96409 10.8456 1.88623 10.8994 1.8015 10.9357C1.71665 10.972 1.62623 10.9903 1.53531 10.9897L1.53228 10.9897C1.44136 10.9903 1.35094 10.972 1.26609 10.9357C1.18147 10.8994 1.10369 10.8457 1.0375 10.7771C0.905399 10.6374 0.829346 10.4462 0.829346 10.2447C0.829346 10.043 0.905517 9.85172 1.03781 9.71202C1.0379 9.71191 1.038 9.71181 1.0381 9.7117L4.41367 6.17224L4.57822 5.9997L4.41367 5.82717L1.0381 2.2877C1.03802 2.28762 1.03795 2.28754 1.03787 2.28746C0.905541 2.14775 0.829346 1.95643 0.829346 1.7547C0.829346 1.55286 0.90563 1.36144 1.0381 1.2217L1.03829 1.2215C1.1043 1.15172 1.18218 1.09701 1.26711 1.05991C1.352 1.02282 1.4426 1.00391 1.5338 1.00391C1.62499 1.00391 1.7156 1.02282 1.80049 1.05991C1.88541 1.09701 1.96329 1.15172 2.0293 1.2215L2.0293 1.2215L2.03001 1.22224L6.07368 5.46224Z",
    fill: "#808191",
    stroke: "#808191",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/arrow-1.0c776102c9fb9170208e2ee1ecb4365b.svg";
export { ForwardRef as ReactComponent };